<template>
  <div class="tool-container">
    <component :is="activeToolComponent" />
    <HelpDocuments v-if="helpActive" />
  </div>
</template>

<script>
import { vuex } from '@/components/mixin/vuex.js'

// Import all available tools here
// Future tools can be added to this map
import LayersTool from '@/components/mapTools/layers/Layers.vue'
import UploadShpKmz from '@/components/mapTools/UploadShpKmz/UploadShpKmz.vue'
import Search from '@/components/mapTools/search/Search.vue'
import Annotations from '@/components/mapTools/annotations/Annotations.vue'
import ChangeBasemap from '@/components/mapTools/baseMap/ChangeBasemap.vue'
import Geoprocessings from '@/components/mapTools/geoprocessings/Geoprocessings.vue'
import MeasureTool from '@/components/mapTools/measures/Measure.vue'
import LocatorTool from './locator/Locator.vue'
import DrawTool from './draw/DrawTool.vue'
import HelpDocuments from '@/components/mapTools/help/HelpDocuments.vue'

export default {
  name: 'ToolContainer',
  mixins: [vuex],
  components: {
    LayersTool,
    UploadShpKmz,
    Search,
    Annotations,
    ChangeBasemap,
    Geoprocessings,
    MeasureTool,
    LocatorTool,
    DrawTool,
    HelpDocuments
  },
  computed: {
    // 'help' se renderiza fuera del switch para permitir paneles simultáneos
    helpActive() {
      return this.mapToolValues('help').active
    },
    activeToolComponent() {
      console.log("Se va a renderizar una herramienta:", this.mapToolSelected)
      switch (this.mapToolSelected) {
        // 'select' case removed — SelectTool is now always-mounted in MapContainer
        case 'layers':
          return 'LayersTool'
        case 'shpKmzUpload':
          return 'UploadShpKmz'
        case 'search':
          return 'Search'
        case 'locator':
          return 'LocatorTool'
        case 'annotations':
          return 'Annotations'
        case 'basemap':
          return 'ChangeBasemap'
        case 'geoprocessing':
          return 'Geoprocessings'
        case 'measures':
          return 'MeasureTool';
        case 'draw':
          return 'DrawTool';
        default:
          return null;
      }
    }
  }
}
</script>

<style scoped>
.tool-container {
  pointer-events: none;
  /* Allow clicks to pass through to map by default */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  /* Ensure it's above the map but below modals/drawers if needed */
}

/* Children (tools) should re-enable pointer-events if they have UI */
.tool-container>* {
  pointer-events: auto;
}
</style>
